// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var AnalyzerLinesType;
(function (AnalyzerLinesType) {
    AnalyzerLinesType[AnalyzerLinesType["VolatilityChange"] = 0] = "VolatilityChange";
    AnalyzerLinesType[AnalyzerLinesType["TimeChange"] = 1] = "TimeChange";
})(AnalyzerLinesType || (AnalyzerLinesType = {}));
